import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/user',
  title: window.language['menu.sysConfig.user'],
  component: dynamicWrapper(app, [import('../Role/model'), import('../SysConfig/model'), import('../../Material/Material/model'), import('../../HomePage/model'), import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/User/index.js